import { useState, useEffect } from 'react'
import { WifiIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { connectionSimulator } from '../services/connectionSimulator'

export default function GlobalOfflineIndicator() {
  const [isOffline, setIsOffline] = useState(false)
  const [showIndicator, setShowIndicator] = useState(false)

  useEffect(() => {
    const updateStatus = () => {
      const offline = connectionSimulator.isSimulatingOfflineMode()
      setIsOffline(offline)
      
      // Show indicator with a slight delay to avoid flashing
      if (offline) {
        setShowIndicator(true)
      } else {
        // Hide indicator after a short delay when coming back online
        setTimeout(() => setShowIndicator(false), 2000)
      }
    }

    // Initial check
    updateStatus()

    // Set up interval to check status
    const interval = setInterval(updateStatus, 1000)

    return () => clearInterval(interval)
  }, [])

  if (!showIndicator) return null

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-orange-500 text-white px-4 py-2 shadow-lg">
      <div className="flex items-center justify-center space-x-2 text-sm font-medium">
        <ExclamationTriangleIcon className="w-4 h-4" />
        <span>🌐 Offline Mode Active - All network requests blocked</span>
        <WifiIcon className="w-4 h-4" />
      </div>
    </div>
  )
} 